import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.397 2c-.598 0-1.172.238-1.595.661L2.66 5.803c-.422.422-.66.996-.66 1.594v5.205c0 .599.238 1.173.661 1.596l3.142 3.142c.422.422.996.66 1.594.66h5.205c.599 0 1.173-.238 1.596-.661l3.142-3.143c.422-.423.66-.996.66-1.594V7.4a2.26 2.26 0 0 0-.662-1.598l-3.14-3.14A2.257 2.257 0 0 0 12.6 2H7.397ZM10.7 6.4a.7.7 0 0 0-1.4 0v4.8a.7.7 0 0 0 1.4 0V6.4Zm-.607 6.805-.094-.005-.087.005A.799.799 0 0 0 10 14.8a.8.8 0 0 0 .092-1.595Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AlertErrorFilledIcon20.js.map